<template>
		<v-text-field
			v-model="setEmployeeNumber"
			:rules="[rules.employeeNumberFormat]"
			label="社員番号"
			hint="0詰めの3桁で入力してください。 1の場合は001。"
			class="mt-4"
			outlined
			dense
		/>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		employeeNumber: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			rules: rules,
		}
	},
	computed: {
		setEmployeeNumber: {
			get() {
				return this.employeeNumber
			},
			set(newValue) {
				return this.$emit("update:employeeNumber", newValue)
			},
		},
	},
}
</script>
